import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AIPreferencesProvider } from "./contexts/AIPreferencesContext";
import { UsageProvider } from "./contexts/UsageContext";
import { ProgressProvider } from "./contexts/ProgressContext";
import { GuestDemoProvider } from "./contexts/GuestDemoContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AdProvider } from "./contexts/AdContext";
import AuthGate from "./components/feature/AuthGate";
import { runProdReset } from "./utils/prodReset";

function App() {
  runProdReset();
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <ThemeProvider>
          <AIPreferencesProvider>
            <UsageProvider>
              <AdProvider>
                <ProgressProvider>
                  <GuestDemoProvider>
                    <BrowserRouter basename={__BASE_PATH__}>
                      <AuthGate>
                        <AppRoutes />
                      </AuthGate>
                    </BrowserRouter>
                  </GuestDemoProvider>
                </ProgressProvider>
              </AdProvider>
            </UsageProvider>
          </AIPreferencesProvider>
        </ThemeProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;